import { __decorate, __metadata } from "tslib";
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { proxy, subscribe } from '@/infrastructure/object-reactive/object-reactive';
let SelectedListModelImpl = class SelectedListModelImpl {
    constructor() {
        this._selectedList = proxy([]);
    }
    get selectedList() {
        return this._selectedList.value;
    }
    updateSelectedList(selectedList) {
        this._selectedList.value = selectedList;
    }
    addBatchSelectedItems(ids) {
        this._selectedList.value = [...this.selectedList, ...ids];
    }
    addSelectedItem(id) {
        this._selectedList.value = [...this.selectedList, id];
    }
    removeBatchSelectedItems(ids) {
        this._selectedList.value = this.selectedList.filter((item) => !ids.includes(item));
    }
    removeSelectedItem(id) {
        this._selectedList.value = this.selectedList.filter((item) => item !== id);
    }
    clearSelectedList() {
        this._selectedList.value = [];
    }
    getSelectedList() {
        return this.selectedList;
    }
    checkIsSelected(id) {
        return this.selectedList.includes(id);
    }
    subscribe(callback) {
        return subscribe(() => this._selectedList.value, (newVal) => callback(newVal));
    }
};
SelectedListModelImpl = __decorate([
    injectable(),
    __metadata("design:paramtypes", [])
], SelectedListModelImpl);
export { SelectedListModelImpl };
